import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import TipTapEditor from '../../components/TipTapEditor';
import './Admin.css';

function AdminPostForm({ onLogout }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    slug: '',
    category: 'RPGs',
    featured_image: '',
    excerpt: '',
    body: '',
    featured: false
  });

  const categories = ['RPGs', 'Walkthroughs', 'Tips & Tricks', 'Reviews', 'Gear & Setups', 'News'];

  useEffect(() => {
    if (slug) {
      fetchPost();
    }
  }, [slug]);

  const fetchPost = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/posts/${slug}`);
      const data = await response.json();
      setFormData(data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });

    if (name === 'title' && !slug) {
      const generatedSlug = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      setFormData(prev => ({ ...prev, slug: generatedSlug }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');
      const url = slug
        ? `${process.env.REACT_APP_BACKEND_URL}/api/admin/posts/${slug}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/admin/posts`;

      const response = await fetch(url, {
        method: slug ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        navigate('/admin/posts');
      } else {
        const data = await response.json();
        alert(data.detail || 'Error saving post');
      }
    } catch (error) {
      alert('Error saving post');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <nav className="admin-nav">
        <div className="admin-nav-content">
          <h1 className="brand-text">ClutchBabe9 Admin</h1>
          <div className="admin-nav-links">
            <Link to="/admin/dashboard" className="admin-nav-link">Dashboard</Link>
            <Link to="/admin/posts" className="admin-nav-link active">Posts</Link>
            <Link to="/admin/videos" className="admin-nav-link">Videos</Link>
            <Link to="/admin/subscribers" className="admin-nav-link">Subscribers</Link>
            <Link to="/admin/contacts" className="admin-nav-link">Contacts</Link>
            <Link to="/admin/profile" className="admin-nav-link">Profile</Link>
            <Link to="/admin/config" className="admin-nav-link">Settings</Link>
            <Link to="/" className="admin-nav-link view-site-link" data-testid="view-site-btn">🌐 View Site</Link>
            <button onClick={() => { onLogout(); navigate('/admin/login'); }} className="btn btn-ghost">Logout</button>
          </div>
        </div>
      </nav>

      <div className="admin-content">
        <div className="admin-header">
          <h2>{slug ? 'Edit Post' : 'Create New Post'}</h2>
          <Link to="/admin/posts" className="btn btn-secondary">Back to Posts</Link>
        </div>

        <form onSubmit={handleSubmit} className="admin-form">
          <div className="form-row">
            <div className="form-group">
              <label>Title *</label>
              <input type="text" name="title" value={formData.title} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Slug *</label>
              <input type="text" name="slug" value={formData.slug} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Category *</label>
              <select name="category" value={formData.category} onChange={handleChange} required>
                {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Featured Image URL *</label>
              <input type="url" name="featured_image" value={formData.featured_image} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-group">
            <label>Excerpt *</label>
            <textarea name="excerpt" value={formData.excerpt} onChange={handleChange} rows="3" required />
          </div>

          <div className="form-group">
            <label>Content *</label>
            <TipTapEditor 
              value={formData.body} 
              onChange={(value) => setFormData({ ...formData, body: value })} 
            />
          </div>

          <div className="form-group">
            <label>
              <input type="checkbox" name="featured" checked={formData.featured} onChange={handleChange} />
              Mark as Featured
            </label>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : slug ? 'Update Post' : 'Create Post'}
            </button>
            <Link to="/admin/posts" className="btn btn-ghost">Cancel</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminPostForm;
